import type { CurrentUser } from '@brimostech/shared';
import { useAuth } from '@/features/auth/auth-context';

/** Optional modules a condominium can turn on (`settings.modules`). */
export type ModuleName = 'visitors' | 'packages' | 'announcements' | 'finance';

/** True when the active condominium has the module on (operators follow the same flag). */
export function moduleEnabled(user: CurrentUser | null, name: ModuleName): boolean {
  if (!user?.activeCondominiumId) return false;
  const active = user.condominiums?.find((c) => c.id === user.activeCondominiumId);
  return active?.modules?.[name] === true;
}

export function useModule(name: ModuleName): boolean {
  const { user } = useAuth();
  return moduleEnabled(user, name);
}

/** False when the active condominium has no blocks/towers (ADR-098): block UI is hidden. */
export function blocksEnabled(user: CurrentUser | null): boolean {
  if (!user?.activeCondominiumId) return true;
  const active = user.condominiums?.find((c) => c.id === user.activeCondominiumId);
  return active?.blocks !== false;
}

export function useBlocks(): boolean {
  const { user } = useAuth();
  return blocksEnabled(user);
}
